import { ScheduleSyncStatus } from '../types/MachineDetailsRobotSchedule.types';
import { SYNC_STATUS_MINUTES_AGO_LIMIT_MS, SYNC_STATUS_UP_TO_DATE_MS } from './constants';
import type { Optional } from 'lib/types/Optional';

export const getScheduleSyncStatus = (lastSyncedAt: Optional<string>, now: number): Optional<ScheduleSyncStatus> => {
  if (!lastSyncedAt) {
    return null;
  }

  const ageMs = Math.max(0, now - new Date(lastSyncedAt).getTime());

  if (ageMs < SYNC_STATUS_UP_TO_DATE_MS) {
    return { kind: 'upToDate' };
  }

  if (ageMs < SYNC_STATUS_MINUTES_AGO_LIMIT_MS) {
    return { kind: 'minutesAgo', minutes: Math.floor(ageMs / 60_000) };
  }

  return { kind: 'dateTime', syncedAt: lastSyncedAt };
};
